<template>
    <div class="default-loading-container">
        <div class="col-12 justify-content-center loading-spinner">
            <div class="spinner-border" role="status">
                <span class="sr-only">{{ translate.home.loading }}...</span>
            </div>
            <span>{{ translate.home.loading }}...</span>
        </div>
    </div>
</template>
<script>
export default {
    computed: {
        ...mapState(['translate'])
    }
}
</script>
